export default __webpack_public_path__ + "static/media/icons-policies.05d85dfd.svg";